<template>
  <div class="page">
    <Header>
      <template #title>
        <span>リトル・ママオンラインフェスタ</span>
        抽選会プレゼント一覧
      </template>
    </Header>
    <div class="presents-wrapper">
      <div class="inner">
        <Heading>
          <template #heading>
            プレゼント抽選会は終了しました。
          </template>
        </Heading>
        <div class="presents">
          <Present
            v-for="(present, index) in presents" :key="index"
            :present="present"
          />
        </div>
      </div>
    </div>
    <!-- <Floating>
      <template #content>
        <Button style="display: block;" />
      </template>
    </Floating> -->
  </div>
</template>

<script>
import Header from '@/components/organisms/202010tsuruha/Header.vue'
import Heading from '@/components/atoms/Heading.vue'
import Present from '@/components/molecules/Present.vue'
import Floating from '@/components/molecules/Floating.vue'
import Button from '@/components/atoms/202010tsuruha/Button.vue'

export default {
  name: 'present',
  components: {
    Header,
    Heading,
    Present,
    Floating,
    Button
  },
  data: () => ({
    presents: [
      {
        thumbnail: '/img/present10tsuruha/tsuruha01present.png',
        name: 'ツルハグループ商品券（10万円）',
        num: '2名',
        day: '両日',
        description: 'ツルハドラッグ店舗及びツルハグループの店舗（くすりの福太郎・ドラッグストアウェルネス・ウォンツ・くすりのレデイ・メディコ21・B&Dドラッグストア・杏林堂スーパードラッグストア）にてご利用いただける商品券です。<br>※お釣りは出ませんのでご了承ください。<br>※調剤(処方箋)のお支払いにはご利用いただけません。<br>※ドラッグイレブンではご利用いただけません。',
        company: 'ツルハドラッグ',
        url: 'https://www.tsuruha.co.jp/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha02present.png',
        name: 'ツルハグループ商品券（5万円）',
        num: '4名',
        day: '両日',
        description: 'ツルハドラッグ店舗及びツルハグループの店舗（くすりの福太郎・ドラッグストアウェルネス・ウォンツ・くすりのレデイ・メディコ21・B&Dドラッグストア・杏林堂スーパードラッグストア）にてご利用いただける商品券です。<br>※お釣りは出ませんのでご了承ください。<br>※調剤(処方箋)のお支払いにはご利用いただけません。<br>※ドラッグイレブンではご利用いただけません。',
        company: 'ツルハドラッグ',
        url: 'https://www.tsuruha.co.jp/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha03present.png',
        name: 'Nintendo Switch',
        num: '1名',
        day: '10/3(土)',
        description: '「Nintendo Switch」は、さまざまなプレイシーンにあわせてカタチを変えるゲーム機。いつでも、どこでも、気の向くままに。自由なプレイスタイルでゲームを楽しむことができます。',
        company: '任天堂ホームページ',
        url: 'https://www.nintendo.co.jp/hardware/switch/feature/index.html'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha04present.png',
        name: 'dyson V7',
        num: '1名',
        day: '10/3(土)',
        description: '大きなゴミから小さなゴミまで同時に吸い取ります。コードのいらない解放感。最長30分の運転時間。安定したパワー供給で変わらない吸引力が続きます。ツールを切り替えて、高い場所もお掃除できます。さまざまな床だけでなく、高い場所や家具の下、床の隙間も、自在に掃除できます。',
        company: 'ダイソン株式会社',
        url: 'https://www.dyson.co.jp/dyson-vacuums/cordless/dyson-v7/dyson-v7.aspx'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha05present.png',
        name: 'BALMUDA The Toastar',
        num: '1名',
        day: '10/2(金)',
        description: '外はサクッと中はしっとり。スチームテクノロジーと徹底した温度制御で、自宅で「焼きたて直後」の香りと食感を実現できるバルミューダのトースター。さらに温度制御を進化させ、上質なデザインにリニューアルしました。1度は使ってみたい憧れのトースターです。',
        company: 'バルミューダ株式会社',
        url: 'https://www.balmuda.com/jp/toaster/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha06present.png',
        name: 'ココット・エブリィ 18 オレンジ ',
        num: '1名',
        day: '10/2(金)',
        description: '日本人のライフスタイルに合わせてフランスの職人と一緒に開発した鋳物ホーロー鍋。効率よく熱の対流が起きるため、炊飯に最適。抜群の熱伝導で、スープや煮込み料理もおいしく出来上がります。',
        company: 'ル・クルーゼ ジャポン株式会社',
        url: 'https://www.lecreuset.co.jp/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha07present.png',
        name: '低温調理器BONIQ （マットブラック）',
        num: '2名',
        day: '10/2(金)',
        description: '素材の旨みを最大限に引き出すから、過度な味付けや不要な添加物は必要なし。しかも、低温度帯＆フリーザーバッグを使った調理栄養素を逃しにくく、フリーザーバッグを使った調理だから、流出してしまった栄養素も丸ごと摂取できます。さらに、BONIQ公式の低温調理レシピは300以上！高タンパクで栄養価の高いレシピを豊富にご紹介しています。',
        company: '株式会社葉山社中',
        url: 'https://boniq.store/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha08present.png',
        name: 'tak. KIDS DISH gift box bear cutlery',
        num: '6名',
        day: '両日',
        description: 'なめらかな口元、高度な塗装技術によるスムースな手触り。こども達にこそ、質のよいもので食べることを楽しんで欲しい。tak.のキッズディッシュでの食事の時間をもっと笑顔に。',
        company: '株式会社 竹中',
        url: 'https://takenaka-foodware.jp/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha09present.png',
        name: '電子体温計 MC-681　けんおんくん',
        num: '2名',
        day: '両日',
        description: '［予測式］平均20秒の予測検温。検温結果が見やすく、使いやすいスタンダードタイプ。検温を開始してからの体温の変化を、当社独自の分析・演算技術で高速演算処理し、約20秒で約10分後の体温を予測します。検温結果は大きな文字で見やすく表示。先端が平らになった、オムロン独自のフラット形状を感温部に採用。わきにしっかりフィットしてずれにくいため、誰でも簡単に正しく検温できます。',
        company: 'オムロン ヘルスケア株式会社',
        url: 'https://www.healthcare.omron.co.jp/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha10present.png',
        name: '上腕式血圧計 HCR-7106',
        num: '2名',
        day: '両日',
        description: 'カフが正しく巻けているか確認できる、スタンダードモデル。片手でかんたんに巻けるフィットカフを搭載。正確に血圧を測定するには、カフ（腕帯）を腕にしっかりと巻くことが大切です。「カフぴったり巻きチェック」は、測定のたびに、カフが適切な強さで巻けているかどうかをチェックし、画面でお知らせします。カフそのものが腕にフィットし、片手で簡単にぴったり巻けるオムロン独自の「フィットカフ」が、さらに進化しました。腕にカフを巻いたときに、正しい位置から左右にずれてしまっても、正確に測定することができます。＜適応腕周：17～36cm＞',
        company: 'オムロン ヘルスケア株式会社',
        url: 'https://www.healthcare.omron.co.jp/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha11present.png',
        name: '体重体組成計 HBF-212　カラダスキャン',
        num: '2名',
        day: '両日',
        description: 'シンプル機能＆ガラス仕様のスリムデザイン。コンパクトで収納しやすいA4サイズ。厚さは28mmと、狭いスペースにも収納できるスリムサイズ。4隅には滑り止めゴムがついているので、床を傷つけることなく、安全に収納することができます。また、裏面はくぼみのある持ちやすい形状なので、楽に取り出しや片づけができます。ガラス天板のフラットデザインなので、埃がたまりにくく、お手入れも簡単。毎日気持ちよく使えます。',
        company: 'オムロン ヘルスケア株式会社',
        url: 'https://www.healthcare.omron.co.jp/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha12present.png',
        name: 'リカペイでピッ。おかいものパーク',
        num: '1名',
        day: '10/3(土)',
        description: 'リカちゃんの大きなショッピングモールです。本物みたいな小物100個入り！色々な商品を選んだらセルフレジでお会計！お支払いはリカペイでピッ！エスカレーターで2階へ上がれます。2階のボードを裏返すと屋上庭園になります。',
        company: '株式会社タカラトミー',
        url: 'https://www.takaratomy.co.jp/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha13present.png',
        name: 'スイスイおえかき  あか',
        num: '3名',
        day: '10/2(金)',
        description: '水で描くから汚れない！小さなお子さまのおえかきデビューにぴったりなおえかき玩具。78×78ｃｍの大きなおえかきシートはお水で発色し乾くと消えるので、洋服や周囲を汚すことなく何度でもくりかえしあそべます。',
        company: 'パイロットインキ（株）',
        url: 'https://www.pilot-toy.com/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha14present.png',
        name: 'かえちゃOh!!  まほうのおすしやさん',
        num: '3名',
        day: '10/3(土)',
        description: '不思議なお寿司がお湯と氷水で何度でも色が変わる！男の子も女の子もみんなで楽しくお寿司やさんごっこができるセット。お寿司をにぎって、まほうのハケやスポイトで氷水をかけると別のお寿司に変わります。お風呂でもお部屋でも遊べます。',
        company: 'パイロットインキ（株）',
        url: 'https://www.pilot-toy.com/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha15present.png',
        name: 'ブランド米食べ比べセット（2㎏×3種）',
        num: '5名',
        day: '10/3(土)',
        description: '人気の高いブランド米（ゆめぴりか・青天の霹靂・魚沼コシヒカリ）3種セットです。いつもと違うお米で、普段よりちょっぴり特別な食卓に…是非この機会に食べ比べをお楽しみください！チャック付き容器で保存にも便利。そのまま立てて保管できます。',
        company: '全農パールライス株式会社',
        url: 'https://www.zpr.co.jp/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha16present.png',
        name: 'リンレン レメディアル シャンプー・トリートメント ミント＆レモン',
        num: '5名',
        day: '10/2(金)',
        description: '頭皮環境を整える有効成分と10種の国産植物原料、頭皮の皮脂よごれをしっかりと吸着して取り除く山形県産天然クレイを配合した、薬用スカルプシャンプー。毛髪・頭皮を健やかに保ち、汗臭、ふけ・かゆみを防ぎます。北海道産和ミントと愛媛県産レモンの冷涼ですっきりとした香り。',
        company: '株式会社ビーバイ・イー',
        url: 'https://www.bxe.co.jp/rinren/'
      },
      {
        thumbnail: '/img/present10tsuruha/tsuruha17present.png',
        name: 'DaG3 navy（ダッグスリー ネイビー）',
        num: '1名',
        day: '10/3(土)',
        description: 'ウエストポーチがヒップシートに変化します。長財布や500mlのペットボトル、替えおむつ等収納できます。外出先での抱っこはもちろん、おうちの中での寝かしつけ、授乳の補助等横抱きにも使えます。装着も簡単なのでおじいちゃん、おばあちゃんにもおすすめです。',
        company: '株式会社ジャナ・ジャパン ブランド名　TeLasbaby',
        url: 'https://www.telasbaby.jp/'
      }
    ]
  }),
  mounted () {
    document.title = '抽選会プレゼント一覧 - リトル・ママオンラインフェスタ'
  }
}
</script>

<style lang="sass" scoped>
.page
  padding: 60px 0 100px
.presents-wrapper
  background-color: $lightpink
  padding: 25px 0
  .explanation
    margin: 30px 0
    .name
      font-size: 20px;
      margin-bottom: 10px;
      color: #EC83A4;
    .comment
      font-size: 15px
  .presents
    .present
      margin-top: 25px
</style>
